import { Chip } from "@mui/material"
import useConstants from "hooks/useConstants"
import { KDropdown, KSpan } from "kahuna-base-react-components"
import { useEffect, useState } from "react"
import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { ReportUploadRequestFilterType, ReportUploadRequestStatus } from "types/reports"

const ReportsUploadRequestFilter = ({
  filter,
  setFilter
}: {
  filter: ReportUploadRequestFilterType
  setFilter: (filter: ReportUploadRequestFilterType) => void
}) => {
  const { distributors, fetchDistributors } = useConstants()

  const [selectedDistributors, setSelectedDistributors] = useState<KSelectOption[]>(
    filter.distributorList?.map((value: string, index: number) => {
      return {
        value: index,
        label: distributors.find((distributor) => distributor.value === value)?.name,
        value2: value
      }
    }) as KSelectOption[]
  )

  useEffect(() => {
    const selectedDis = filter.distributorList?.map((value: string, index: number) => {
      return {
        value: index,
        label: distributors.find((distributor) => distributor.value === value)?.name,
        value2: value
      }
    }) as KSelectOption[]
    setSelectedDistributors(selectedDis)
  }, [filter, distributors])

  useEffect(() => {
    if (distributors.length === 0) fetchDistributors()
  }, [])

  const renderChips = (key: string, options: string[]) => {
    return options.map((option) => {
      return (
        <Chip
          key={option}
          label={option}
          className="ml-1 mt-1"
          onClick={() => {
            const currentStatusList = { ...filter }.statusList
            if (currentStatusList?.includes(option)) {
              const updatedStatusList = currentStatusList.filter((status) => status !== option)
              setFilter({ ...filter, statusList: updatedStatusList })
            } else {
              //@ts-ignore
              setFilter({ ...filter, statusList: [...filter.statusList, option] })
            }
          }}
          //@ts-ignore
          variant={filter.statusList.includes(option) ? "filled" : "outlined"}
        />
      )
    })
  }

  const onFilterDistributor = (valueList?: string[]) => {
    setFilter({ ...filter, distributorList: valueList })
  }

  return (
    <div>
      <div className="mb-2 flex justify-between">
        <div className="flex items-center gap-2">
          <KSpan text="Distributor:" fontWeight={600} fontSize={15} color="black" />
          <KDropdown
            isMulti={true}
            closeMenuOnSelect={false}
            width={240}
            defaultValue={selectedDistributors}
            selected={selectedDistributors}
            onSelect={(value) => setSelectedDistributors(value as KSelectOption[])}
            onBlur={(selected) =>
              onFilterDistributor((selected as KSelectOption[])?.map((option) => option.value2 || ""))
            }
            options={distributors.map((option) => {
              return { label: option.name, value: option.id, value2: option.value }
            })}
          />
        </div>
        <div>
          {renderChips("status", [
            ReportUploadRequestStatus.UPLOAD_IN_PROGRESS,
            ReportUploadRequestStatus.UPLOAD_FAILED,
            ReportUploadRequestStatus.UPLOAD_PARTIAL_SUCCESS,
            ReportUploadRequestStatus.DRAFT,
            ReportUploadRequestStatus.REVIEWING,
            ReportUploadRequestStatus.REQUEST_APPROVED,
            ReportUploadRequestStatus.REQUEST_DISAPPROVED
          ])}
        </div>
      </div>
    </div>
  )
}

export default ReportsUploadRequestFilter
